<!--
 * @Description: 接入IoT设备协议的数量
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-18 17:05:20
 * @LastEditors: @Xin (834529118@qq.com)
 * @LastEditTime: 2021-08-05 10:04:47
 -->
<template>
  <div class="connectIotDevice">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">接入IOT设备协议的数量</span>
    </div>
    <div class="list">
      <!-- <div class="item" v-for="(item, index) in connectIotDeviceData" :key="index">
        <span class="title">{{item.typeName}}</span>
        <el-progress :percentage="item.num * 100 / connectIotDeviceData[0].num" :color="activeColor[index]" :format="progressFormat(item.num)"></el-progress>
      </div> -->
      <div class="item">
        <span class="title">多媒体发布</span>
        <el-progress :percentage="mediaPercentage" color="#ffff00" :format="progressFormat(connectIotDeviceData.media)"></el-progress>
      </div>
      <div class="item">
        <span class="title">车位管理类</span>
        <el-progress :percentage="parkingLotPercentage" color="#00ff00" :format="progressFormat(connectIotDeviceData.parkingLot)"></el-progress>
      </div>
      <div class="item">
        <span class="title">安防监控类</span>
        <el-progress :percentage="SecurityMonitoringPercentage" color="#03f7f7" :format="progressFormat(connectIotDeviceData.SecurityMonitoring)"></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'connectIotDevice',
  components: {
  },
  data () {
    return {
      connectIotDeviceData: {},
      activeColor: [
        '#ff8400',
        '#ffff00',
        '#00ff00',
        '#03f7f7',
      ],
    }
  },
  methods: {
    /**
     * @description                   获取接入IoT设备数据
     * @return {undefied}             无返回值
     */
    getconnectIotDeviceData () {
      this.$http.get('/rest/screen/zhfwq/devices')
        .then(res => {
          if (res.code === 0) {
            this.connectIotDeviceData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   进度条内容格式化
     * @param                         内容
     * @return {undefied}             无返回值
     */
    progressFormat (value) {
      return () => {
        return Number(value)
      }
    },
  },
  computed: {
    mediaPercentage () {
      const { connectIotDeviceData } = this
      return connectIotDeviceData.length ? connectIotDeviceData.media * 100 / connectIotDeviceData[Object.keys(connectIotDeviceData)[0]] : 0
    },
    parkingLotPercentage () {
      const { connectIotDeviceData } = this
      return connectIotDeviceData.length ? connectIotDeviceData.parkingLot * 100 / connectIotDeviceData[Object.keys(connectIotDeviceData)[0]] : 0
    },
    SecurityMonitoringPercentage () {
      const { connectIotDeviceData } = this
      return connectIotDeviceData.length ? connectIotDeviceData.SecurityMonitoring * 100 / connectIotDeviceData[Object.keys(connectIotDeviceData)[0]] : 0
    },
  },
  created () {
    this.getconnectIotDeviceData()
  },
}
</script>

<style lang="less" scoped>
  .connectIotDevice {
    width: 100%;
    height: 100%;
    font-size: 20px;
    .titleHeader {
      width: 100%;
      height: 40px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .list {
      width: 100%;
      height: calc(100% - 40px);
      overflow-y: scroll;
      .item {
        width: 100%;
        height: 16.66%;
        display: flex;
        align-items: center;
        .title {
          display: inline-block;
          width: calc(35% - 20px);
          padding-right: 10px;
          color: #fff;
          vertical-align: middle;
          font-size: 18px;
          text-align: right;
        }
        /deep/.el-progress {
          display: inline-block;
          width: 65%;
          .el-progress-bar {
            .el-progress-bar__outer {
              background: #1b3134;
            }
          }
          .el-progress__text {
            color: #fff;
          }
        }
      }
    }
  }
</style>
